module.exports = " <div class=mask :class=\"{ 'mask-hidden': bgc === 'false' }\"> <div class=loading> <div class=loading-icon></div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./web/components/loading/loading.vue
// module id = 93
// module chunks = 0 7 24 25 26 30 39 48 49 52 77 82 93 94 95 100 101 103 104 105 106 109 111 113 114 171 172 174